(function (appComponents) {

	appComponents.services.modals = function (Components) {

		var modals = {};

		modals.name = "modals";

		Components.getComponentPrototype().extend(modals);

		modals.elements = {
			get success() {
				return $('[pc-container="modal--success"]');
			},
			get warning() {
				return $('[pc-container="modal--warning"]');
			},
			get error() {
				return $('[pc-container="modal--error"]');
			},
			get loading() {
				return $('[pc-container="modal--loading"]');
			},
			get confirm() {
				return $('[pc-container="modal--confirm"]');
			}

		};

		modals.bindings = function () {
			modals.elements.confirm.on('click', '[pc-container="modal--confirm-btns"]', function () {
				var value = $(this).data('confirm');
				modals.confirm.resolveDeferred(value);
			});
		};

		var modalPrototype = {
			get messageContainer() {
				return this.el.find('[pc-container="modal--message"]');
			},
			show: function (message) {
				this.messageContainer.text(message);
				this.el.modal("show");
			},
			hide: function () {
				this.el.modal("hide");
			},
			showHtml: function (html) {
				this.messageContainer.html(html);
				this.el.modal("show");
			}
		};

		modals.success = {
			get el() {
				return modals.elements.success;
			},
			showAddedToCartMessage: function (succededProducts) {
				var context = {
					succededProducts: succededProducts
				};
				var html = modals.templates.successAddToCartItems(context);
				this.messageContainer.html(html);
				this.el.modal("show");
			},
			showAppliedPandaInCartMessage: function (succededProducts) {
				var context = {
					succededProducts: succededProducts
				};
				var html = modals.templates.successAppliedPandaCartItems(context);
				this.messageContainer.html(html);
				this.el.modal("show");
			},
			__proto__: modalPrototype
		};

		modals.error = {
			get el() {
				return modals.elements.error;
			},
			__proto__: modalPrototype
		};
        
        modals.errorPopup = {
            get el() {
                return modals.elements.error;
            },
            showAddedToCartMessage: function (succededProducts, errorProducts) {
                var html = "";
                 var context = {
                    succededProducts: succededProducts,
                    errorProducts: errorProducts
                };
              if (context.succededProducts.length) {
                    html = modals.templates.successAddToCartItems(context);
                }
             html = html + modals.templates.errorAddToCartItems(context);
             this.messageContainer.html(html);
              this.el.modal("show");
              },
            __proto__: modalPrototype
        };

		modals.loading = {
			get el() {
				return modals.elements.loading;
			},
			//show and hiding loading for search-results
			show : function (){
				this.el.modal("show");
			},
			hide : function(){
				this.el.modal("hide");
			},
			__proto__: modalPrototype
		};

		modals.warning = {
			get el() {
				return modals.elements.warning;
			},
			showAddedToCartMessage: function (succededProducts, errorProducts) {
				var html = "";

				var context = {
					succededProducts: succededProducts,
					errorProducts: errorProducts
				};

				if (context.succededProducts.length) {
					html = modals.templates.successAddToCartItems(context);
				}

				html = html + modals.templates.errorAddToCartItems(context);

				this.messageContainer.html(html);

				this.el.modal("show");

			},
			showAppliedPandaInCartMessage: function (succededProducts, errorProducts) {
				var html = "";

				var context = {
					succededProducts: succededProducts,
					errorProducts: errorProducts
				};

				if (context.succededProducts.length) {
					html = modals.templates.successAppliedPandaCartItems(context);
				}

				html = html + modals.templates.errorAppliedPandaCartItems(context);

				this.messageContainer.html(html);

				this.el.modal("show");
			},
			showquoteToCartWarningMessage: function () {
				var html = "";
				var context = {
				
				};
				html = modals.templates.quoteToOrderConversionWarning(context);
				this.messageContainer.html(html);
				this.el.modal("show");
			},
			__proto__: modalPrototype
		};

		modals.confirm = {
			get el() {
				return modals.elements.confirm;
			},
			defConfirm: null,
			showConfirm: function (message) {
				this.show(message);
				return this.defConfirm = $.Deferred();
			},
			resolveDeferred: function (value) {
				this.defConfirm.resolve(value);
				this.hide();
			},
			__proto__: modalPrototype
		};


		modals.handlers = {

		};

		modals.init = function () {

			modals._bindings();

		};

		return modals;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});